import {
  DropDownQuestion,
} from "../../../types/Question";

// <select 
//   label="Q10">
//   <title>New Dropdown Menu Question</title>
//   <comment>Please select one for each.</comment>
//   <choice label="ch1">Sample Choice #1</choice>
//   <choice label="ch2">Sample Choice #2</choice>
// </select>
/**
 * Export question as XML-precursor data type.
 *
 * @export
 * @param {DropDownQuestion} question
 * @return {*}
 */
export default function toXmlType(question: DropDownQuestion) {
  return {
    number: {
      _attributes: {
        label: `Q${question.id}`,
      },
      title: question.title,
      choice: [
        ...question.options.map((o) => {
          return {
            _attributes: {
              label: `ch${o.id}`,
              value: `${o.id}`,
            },
            _text: o.name,
          };
        }),
      ],
    },
  };
}
